import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import BlogRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => loadContentMeta("blog_posts", params.slug, "en"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/blog/${params.slug}`, loaderData),
  component: BlogRedirect,
});

